export default __webpack_public_path__ + "static/media/empty_flux.84e36dcc.png";